import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/frontend/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { Oswald } from 'Shared/frontend/fonts/Oswald';
import { Alatsi } from 'Shared/frontend/fonts/Alatsi';
import { ExpletusSans } from 'Shared/frontend/fonts/Expletus';
import { OpenSans } from 'Shared/frontend/fonts/OpenSans';
import { Calendar } from 'Shared/frontend/icons/Calendar';
import { Contact } from 'Shared/frontend/icons/Contact';
import { Home } from 'Shared/frontend/icons/Home';


export class MoshpitSettings extends BaseSettings
{
	palette()
	{
		return {
			background: '#1f1f1f',
			text: 'white',
			feature: 'white',
			feature2: '#EE4447',
			/* Eg the mobile nav colour */
			dimBackground: 'black', //or lightgray '#2e2e2e'
			food: '#B42111',
			drinks: 'white',
			dateBackground: 'yellow',
			dateText:'',
			eventName:'',
			artistNames:'',
			tagline:'',
			genre:'',
		};
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().feature
				},
				dateBar: {
					backgroundColor: this.palette().background
				},
			}
		});
	}

	fontIncludes()
	{
		return [
			Oswald,
			Alatsi,
			ExpletusSans,
			OpenSans
		];
	}

	fonts()
	{
		return {
			text: '"Expletus Sans", sans-serif',
			heading: '"Expletus Sans", sans-serif',
			buttons: '"Open Sans", sans-serif',
			desktopNav: '"Expletus Sans", sans-serif',
			mobileNav: '"Expletus Sans", sans-serif',
			subNav: '"Expletus Sans", sans-serif',
		};
	}

	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature
			},
		

			section: {
				title: {
					color: this.palette().feature,
					textTransform: 'initial',
			
				},
			},

			button: {
				backgroundColor: this.palette().dimBackground,
				borderRadius: '0.4em',
				borderColor: 'red',
			},
		});
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			nav: {
				desktop: {
					active: {
						color: '#E7D9CB', 
					},
				},
				mobile: {
					active: {
						color: 'red',
					},
				},
			},

			event: {
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						borderRadius: '0.4em',
						color: palette.background,
						lineHeight: '16px'
					},
					buttonType: type => ({ backgroundColor: `${menuNavButtonColour(palette,type)} !important` })
				},
				section: {
					heading: {
						textAlign: 'center',
					},
					headingType: (level:number,section) => ({ color: `${menuItemTitleColour(palette,section)} !important`}),
				},
				item: {
					title: {
						fontWeight: 'bold !important',
					},
					titleType: section => ({color: `${menuItemTitleColour(palette,section)} !important`}),
				}
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	navContent()
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Functions',	link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Functions',	link:'frontend/Hire', 		icon:Contact},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
				]
			}
		};
	}
};

function menuItemTitleColour(palette,props)
{
	if (props.productType == 'food')
		return palette.food;
	else
		return palette.feature;
}

function menuNavButtonColour(palette,type:string)
{
	switch(type) {
		case 'food': return palette.food;
		case 'drinks': return palette.drinks;
	}
	return 'inherit';
}

